import { BridgeNoticeContainer, NoticeBox, NoticeHighlight, NoticeText } from './styles'

export function BridgeNoticeSection() {
  return (
    <BridgeNoticeContainer>
      <NoticeBox>
        <NoticeText>
          안내드린 하자가 있어 판매하기 어렵지만,
          <br />
          <NoticeHighlight>필요하신 분께 배송비만 결제하면 최대 27매를 드려요</NoticeHighlight>
        </NoticeText>
      </NoticeBox>
    </BridgeNoticeContainer>
  )
}
